export default "__VITE_ASSET__C2L1l7ds__"